<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 72 72"
  >
    <path
      style="fill:#FFFFFF;"
      d="M36,4.8c-12.61,0-22.87,10.26-22.87,22.87c0,11.36,18.57,34.7,22.29,39.26L36,67.64l0.58-0.71
  c3.72-4.56,22.29-27.91,22.29-39.26C58.87,15.06,48.61,4.8,36,4.8z"
    />
    <path
      d="M58.12,27.67c0-12.2-9.92-22.12-22.12-22.12c-12.2,0-22.12,9.92-22.12,22.12c0,11.13,18.64,34.52,22.12,38.79
  C39.48,62.18,58.12,38.79,58.12,27.67L58.12,27.67z M24.59,27.67c0-6.29,5.12-11.41,11.41-11.41c6.29,0,11.41,5.12,
  11.41,11.41, S42.29,39.08,36,39.08C29.71,39.08,24.59,33.96,24.59,27.67L24.59,27.67z"
    />
  </svg>
</template>

<script>
export default {
  name: 'BalloonIcon',
};
</script>
